import { authService } from './authService';
import { getServerURL } from './config';

const SERVER_URL = getServerURL();

export const getSceneVersions = async (generationId, sceneOrder) => {
  const response = await fetch(
    `${SERVER_URL}/generations/${encodeURIComponent(generationId)}/scenes/${encodeURIComponent(sceneOrder)}/versions`,
    { headers: authService.getAuthHeaders() }
  );
  const payload = await response.json();
  if (!response.ok) throw new Error(payload?.error || `HTTP error! status: ${response.status}`);
  return payload.data || [];
};

export const activateSceneVersion = async (generationId, sceneOrder, versionId) => {
  const response = await fetch(
    `${SERVER_URL}/generations/${encodeURIComponent(generationId)}/scenes/${encodeURIComponent(sceneOrder)}/versions/${encodeURIComponent(versionId)}/activate`,
    { method: 'POST', headers: authService.getAuthHeaders() }
  );
  const payload = await response.json();
  if (!response.ok) throw new Error(payload?.error || `HTTP error! status: ${response.status}`);
  return payload.data;
};
